export const USER_PROFILE_FETCH_REQUEST = 'user-profile-fetch-request';
export const USER_PROFILE_FETCH_SUCCESS = 'user-profile-fetch-success';
export const USER_PROFILE_FETCH_FAILURE = 'user-profile-fetch-failure';